module.exports = __webpack_public_path__ + "static/media/DSCF2078.aa45ca65.JPG";